import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiStatsV2ReservationMonthlyElFindHospitalParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiStatsV2ReservationMonthlyElFindHospitalParams, unknown>

const fetchStatsReservationMonthlyHospital = async (params: ApiStatsV2ReservationMonthlyElFindHospitalParams) => {
  const { data } = await apiClient.v2.apiStatsV2ReservationMonthlyElFindHospital(params);
  return checkApiResponse(data);
}

export const statsReservationMonthlyHospitalKeys = {
  all: [QUERY_KEY.v2apiStatsV2ReservationMonthlyElFindHospital] as const,
  list: (params: ApiStatsV2ReservationMonthlyElFindHospitalParams) => [...statsReservationMonthlyHospitalKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(statsV2ReservationMonthlyFindHospitalQueryOptions(params))` */
export const statsV2ReservationMonthlyFindHospitalQueryOptions = (params: ApiStatsV2ReservationMonthlyElFindHospitalParams) => ({
  queryKey: statsReservationMonthlyHospitalKeys.list(params),
  queryFn: () => fetchStatsReservationMonthlyHospital(params),
})

export const useStatsV2ReservationMonthlyFindHospitalQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: statsReservationMonthlyHospitalKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchStatsReservationMonthlyHospital(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
